import { render, staticRenderFns } from "./FutureMeLifeArea.vue?vue&type=template&id=35cdc00a&"
import script from "./FutureMeLifeArea.vue?vue&type=script&lang=js&"
export * from "./FutureMeLifeArea.vue?vue&type=script&lang=js&"
import style0 from "./FutureMeLifeArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports